/* import __COLOCATED_TEMPLATE__ from './suggestion-group-list.hbs'; */
/* RESPONSIBLE TEAM: team-messenger */
import templateOnlyComponent from '@ember/component/template-only';
import type { SuggestionGroup } from './types';

interface Args {
  displayedSuggestions: SuggestionGroup[];
  showAllSuggestions: boolean;
  hasMoreSuggestions: boolean;
  remainingCount: number;
  onRemoveSuggestion: (groupUuid: string) => void;
  onToggleShowAll: () => void;
}

interface Signature {
  Element: HTMLDivElement;
  Args: Args;
}

const SuggestionGroupList = templateOnlyComponent<Signature>();
export default SuggestionGroupList;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'MessengerSettings::Sales::SuggestionGroupList': typeof SuggestionGroupList;
  }
}
